"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePDF = exports.asPDF = void 0;
// import PdfPrinter = require('pdfmake');
const renderSection = require("./render/sections");
const renderContent = require("./render/content");
const layout = require("./render/layout");
const styles_1 = require("./render/styles");
const fonts = {
    Helvetica: {
        normal: 'Helvetica',
        bold: 'Helvetica-Bold',
        italics: 'Helvetica-Oblique',
        bolditalics: 'Helvetica-BoldOblique',
    },
    Times: {
        normal: 'Times-Roman',
        bold: 'Times-Bold',
        italics: 'Times-Italic',
        bolditalics: 'Times-BoldItalic',
    },
};
function asPDF(rawExport, exportedBy, options) {
    throw new Error('Not implemented');
    // const printer = new PdfPrinter(fonts);
    const printer = {};
    const content = makePDF(rawExport);
    const now = new Date();
    const pdfDoc = {
        content,
        header: layout.reportHeader(rawExport.meta),
        footer: layout.reportFooter(rawExport.meta, exportedBy, now),
        pageSize: 'LETTER',
        pageMargins: [50, 48],
        styles: styles_1.default,
        pageOrientation: 'portrait',
        defaultStyle: {
            font: 'Times',
            lineHeight: 1.2,
        },
        /** Other options I could include are:
                background?: DynamicBackground | Content | undefined;
                compress?: boolean | undefined;
                images?: { [key: string]: string } | undefined;
                info?: TDocumentInformation | undefined;
                userPassword?: string | undefined;
                ownerPassword?: string | undefined;
                permissions?: PDFKit.DocumentPermissions | undefined;
                watermark?: string | Watermark | undefined;
             */
    };
    const doc = printer.createPdfKitDocument(pdfDoc, options === null || options === void 0 ? void 0 : options.pdfMakeOptions);
    return doc;
}
exports.asPDF = asPDF;
function makePDF(rawExport) {
    var _a;
    if (!rawExport.sections || !rawExport.sections.length)
        throw new Error(`Invalid sections parameter set in raw export. Sections was: ${JSON.stringify(rawExport.sections)}`);
    const content = [];
    content.push(renderContent.documentTitleContent(((_a = rawExport.options) === null || _a === void 0 ? void 0 : _a.documentTitle) || 'Patient Summary Report'));
    for (const section of rawExport.sections) {
        content.push(makeSection(section));
        content.push(renderContent.endSection());
    }
    content.pop(); // remove the last divider
    return content;
}
exports.makePDF = makePDF;
function makeSection(section) {
    if (section.type === 'info') {
        return renderSection.infoSection(section);
    }
    else if (section.type === 'indicator') {
        return renderSection.indicatorSection(section);
    }
    else if (section.type === 'notes') {
        return renderSection.notesSection(section);
    }
    else if (section.type === 'ongoing') {
        return renderSection.ongoingSection();
    }
    else if (section.type === 'comment') {
        return renderSection.renderCommentSection(section);
    }
    else if (section.type === 'end') {
        return renderSection.endDocumentSection();
    }
    else {
        return renderSection.defaultSection(section);
    }
}
//# sourceMappingURL=index.js.map